import type { ServiceQualityStatsDto } from './operator-service-quality.types';

/** Stand-in payload until the service-quality stats API is designed. */
export const OPERATOR_SERVICE_QUALITY_STATS_MOCK: ServiceQualityStatsDto = {
  sessionSuccess: {
    ratePercent: 94,
    targetPercent: 95,
  },
  customerRating: {
    rating: 4.2,
    ratingMax: 5,
    surveyCount: 1248,
  },
  dropOffCauses: [
    { id: 'payment-timeout', label: 'Payment Timeout', percent: 34 },
    { id: 'address-validation', label: 'Address Validation', percent: 28 },
    { id: 'cart-abandonment', label: 'Cart Abandonment', percent: 19 },
  ],
  ownedSites: {
    id: 'owned',
    siteCount: 20,
    avgSessionSuccessPercent: 96,
    sessionSuccessDeltaPercent: 1.2,
    avgCustomerRating: 4.5,
    ratingMax: 5,
    goodStandingSites: 18,
  },
  managedSites: {
    id: 'managed',
    siteCount: 200,
    avgSessionSuccessPercent: 96,
    sessionSuccessDeltaPercent: 1.2,
    avgCustomerRating: 4.5,
    ratingMax: 5,
    goodStandingSites: 18,
  },
  locations: [
    {
      id: 'horizon-mall',
      location: 'Horizon Mall',
      region: 'Île-de-France',
      sessionSuccessPercent: 92,
      avgRating: 3.2,
      ratingMax: 5,
      status: 'critical',
    },
    {
      id: 'east-paris-hotel',
      location: 'East Paris Hotel',
      region: 'Île-de-France',
      sessionSuccessPercent: 94,
      avgRating: 3.8,
      ratingMax: 5,
      status: 'warning',
    },
    {
      id: 'lyon-central',
      location: 'Lyon Central',
      region: 'Auvergne-Rhône-Alpes',
      sessionSuccessPercent: 98,
      avgRating: 4.5,
      ratingMax: 5,
      status: 'good',
    },
  ],
  urgentSiteCount: 2,
  escalationNoteSiteIds: ['horizon-mall', 'east-paris-hotel'],
};
